import React from "react";
import RankingView from "../components/social/RankingView";
import { useI18n } from "../services/i18n";
import "../styles/content.css";

export default function Ranking() {
  const { t } = useI18n();
  return (
    <div style={{ maxWidth: 760, margin: "0 auto" }}>
      <div className="page-head"><div><h1>🏆 {t("จัดอันดับ")}</h1><p>ตัวละคร จักรวาล และครีเอเตอร์มาแรง นับจากกิจกรรมจริงในช่วงเวลาที่เลือก</p></div></div>
      <RankingView />
    </div>
  );
}
